import { useState } from 'react';
import {
  FaCog,
  FaTruck,
  FaEnvelope,
  FaMapMarkerAlt,
  FaBullseye,
  FaSearchLocation,
} from 'react-icons/fa';
import assasLogo from '../../../assets/asaas-logo.svg';
import {
  ContainerLoja,
  ContentLoja,
  SettingsCard,
  CardHeader,
  ToggleRow,
  LojaInputWrapper,
  InputsLojaWrapper,
  FlexRow,
} from './styles';
import { CustomToggle } from '../../../components/CustomToggle';
import { CustomSelectPicker } from '../../../components/CustomSelectPicker';
import { CustomCheckPicker } from '../../../components/CustomCheckPicker';
import { CustomInput } from '../../../components/CustomInput';
import { CustomButton } from '../../../components/CustomButton';
import { InfoDescription } from '../../../components/InfoDescription';
import { truthy } from '../../../utils/utils';
import {
  deliveryTypesData,
  orderByTypesData,
  timeZoneData,
} from '../constants';
import DataAgendamento from '../components/DiasAgendamento';
import InsertAssasApiKey from '../components/InsertAssasApiKey';
import { useAuth } from '../../../hooks/auth';

let lat = 0;
let long = 0;

const Store = ({ config, change, onChange, setConfig, atualizar }) => {
  const { id_empresa } = useAuth();
  const [modalAgendamento, setModalAgendamento] = useState(false);
  const [insertAsaasModal, setInsertAsaasModal] = useState(false);

  const posicao = () => {
    navigator.geolocation.getCurrentPosition((pos) => {
      lat = pos.coords.latitude;
      long = pos.coords.longitude;
      setConfig((s) => ({ ...s, latitude: lat, longitude: long }));
    });
  };

  return (
    <ContainerLoja>
      <ContentLoja>
        <SettingsCard>
          <CardHeader>
            <FaCog /> <h3>Configurações Gerais</h3>
          </CardHeader>
          <ToggleRow>
            <InfoDescription
              label="Venda fora do horário"
              description="Permite pedidos com a loja fechada"
            />
            <CustomToggle
              checked={truthy(config.vendaLojaFechada)}
              onChange={() =>
                change(
                  'vendaLojaFechada',
                  Number(!truthy(config.vendaLojaFechada)),
                )
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Dias P/ Agendamento"
              description="Configurar calendário de entregas"
            />
            <CustomButton
              appearance="ghost"
              size="sm"
              onClick={() => setModalAgendamento(true)}
            >
              Selecionar
            </CustomButton>
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Retirar Observação"
              description="Remove o campo de OBS nos itens"
            />
            <CustomToggle
              checked={truthy(config.bloquearObs)}
              onChange={() =>
                change('bloquearObs', Number(!truthy(config.bloquearObs)))
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Retirar Totalizador"
              description="Oculta a barra de valor total inferior"
            />
            <CustomToggle
              checked={config.retirarTotalizador}
              onChange={() =>
                change('retirarTotalizador', !config.retirarTotalizador)
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Exibir Bairros"
              description="Mostra lista de bairros atendidos"
            />
            <CustomToggle
              checked={config.exibirBairrosDisponiveis}
              onChange={() =>
                change(
                  'exibirBairrosDisponiveis',
                  !config.exibirBairrosDisponiveis,
                )
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Ordenação Bairros"
              description="Altera ordem na finalização"
            />
            <CustomToggle
              checked={config.orderNeighborhood}
              onChange={() =>
                change('orderNeighborhood', !config.orderNeighborhood)
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Exibir Endereço"
              description="Mostra endereço da loja no cabeçalho"
            />
            <CustomToggle
              checked={config.mostrarEndereco}
              onChange={() =>
                change('mostrarEndereco', Number(!config.mostrarEndereco))
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Exibir Cupom"
              description="Habilita campo de desconto"
            />
            <CustomToggle
              checked={config.showCoupon}
              onChange={() => change('showCoupon', Number(!config.showCoupon))}
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Sugestão de Compra"
              description="Destaques no carrinho"
            />
            <CustomToggle
              checked={config.crossSelling}
              onChange={() => change('crossSelling', !config.crossSelling)}
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Pix Obrigatório"
              description="Exigir comprovante no checkout"
            />
            <CustomToggle
              checked={config.requiredProofOfPayment}
              onChange={() =>
                change('requiredProofOfPayment', !config.requiredProofOfPayment)
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Ocultar Preços"
              description="Esconde valores no cardápio"
            />
            <CustomToggle
              checked={config.hideAppPrice}
              onChange={() => change('hideAppPrice', !config.hideAppPrice)}
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Produtos Mais Pedidos"
              description="Habilita seção de destaques de produtos mais pedidos"
            />
            <CustomToggle
              checked={config.enableMostOrdered}
              onChange={() =>
                change('enableMostOrdered', !config.enableMostOrdered)
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Repetir Pedido"
              description="Habilita botão de repetir pedido na tela de detalhes do pedido para os clientes"
            />
            <CustomToggle
              checked={config.enableRepeatOrder}
              onChange={() =>
                change('enableRepeatOrder', !config.enableRepeatOrder)
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Ver Composição Completa do Produto"
              description="Mostra a composição completa no cartão do produto"
            />
            <CustomToggle
              checked={config.seeCompleteProductComposition}
              onChange={() =>
                change('seeCompleteProductComposition', !config.seeCompleteProductComposition)
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Leve também"
              description="Exibe sugestões de produtos relacionados (cross-sell) na tela do produto, com base no histórico de pedidos."
            />
            <CustomToggle
              id="enableProductSuggestions"
              checked={!!config.enableProductSuggestions}
              onChange={() =>
                change(
                  'enableProductSuggestions',
                  Number(!config.enableProductSuggestions),
                )
              }
            />
          </ToggleRow>
        </SettingsCard>
        <SettingsCard>
          <CardHeader>
            <FaTruck />
            <h3>Logística e Prazos</h3>
          </CardHeader>
          <LojaInputWrapper>
            <InfoDescription label="Fuso Horário" />
            <CustomSelectPicker
              data={timeZoneData}
              onChange={onChange('fusoHorario')}
              value={config.fusoHorario}
            />
          </LojaInputWrapper>
          <LojaInputWrapper>
            <InfoDescription label="Tipos de Entrega" />
            <CustomCheckPicker
              data={deliveryTypesData}
              onChange={onChange('tipoEntregaCheck')}
              value={config.tipoEntregaCheck}
              searchable={false}
            />
          </LojaInputWrapper>
          <InputsLojaWrapper>
            <LojaInputWrapper>
              <InfoDescription label="Frete Grátis (R$)" />
              <CustomInput
                type="number"
                value={config.freteGratis}
                onChange={onChange('freteGratis')}
              />
            </LojaInputWrapper>
            <LojaInputWrapper>
              <InfoDescription label="Mínimo Entrega (R$)" />
              <CustomInput
                type="number"
                value={config.limiteMinimoCompra}
                onChange={onChange('limiteMinimoCompra')}
              />
            </LojaInputWrapper>
            <LojaInputWrapper>
              <InfoDescription label="Ordem Produtos" />
              <CustomSelectPicker
                data={orderByTypesData}
                onChange={onChange('ordenacaoProdutoValor')}
                value={config.ordenacaoProdutoValor}
              />
            </LojaInputWrapper>
          </InputsLojaWrapper>
          <InputsLojaWrapper style={{ marginTop: 10 }}>
            <LojaInputWrapper>
              <InfoDescription label="Tempo Retirada (Entre / Até)" />
              <FlexRow>
                <CustomInput
                  type="time"
                  value={config.minTimePickUp}
                  onChange={onChange('minTimePickUp')}
                />
                <CustomInput
                  type="time"
                  value={config.maxTimePickUp}
                  onChange={onChange('maxTimePickUp')}
                />
              </FlexRow>
            </LojaInputWrapper>
            <LojaInputWrapper>
              <InfoDescription label="Tempo Entrega (Entre / Até)" />
              <FlexRow>
                <CustomInput
                  type="time"
                  value={config.minTimeDelivery}
                  onChange={onChange('minTimeDelivery')}
                />
                <CustomInput
                  type="time"
                  value={config.maxTimeDelivery}
                  onChange={onChange('maxTimeDelivery')}
                />
              </FlexRow>
            </LojaInputWrapper>
          </InputsLojaWrapper>
        </SettingsCard>
        <SettingsCard>
          <CardHeader>
            <FaEnvelope /> <h3>Mensagens do Sistema</h3>
          </CardHeader>
          <LojaInputWrapper>
            <InfoDescription label="Venda Fora do Horário" />
            <CustomInput
              type="text"
              value={config.mensagemVendaLojaFechada || ''}
              onChange={onChange('mensagemVendaLojaFechada')}
              placeholder="Ex.: Compra será entregue no próximo dia útil"
            />
          </LojaInputWrapper>
          <LojaInputWrapper>
            <InfoDescription label="Aviso para Observação" />
            <CustomInput
              type="text"
              value={config.mensagemObs || ''}
              onChange={onChange('mensagemObs')}
            />
          </LojaInputWrapper>
          <LojaInputWrapper>
            <InfoDescription label="Mensagem de Aviso" />
            <CustomInput
              type="text"
              value={config.mensagem || ''}
              onChange={onChange('mensagem')}
              placeholder="Informe a mensagem de aviso para ser apresentando no Catálogo de produtos"
            />
          </LojaInputWrapper>
        </SettingsCard>
        <SettingsCard>
          <CardHeader>
            <FaMapMarkerAlt /> <h3>Localização</h3>
          </CardHeader>
          <InputsLojaWrapper>
            <LojaInputWrapper>
              <InfoDescription label="Latitude" />
              <CustomInput
                type="text"
                value={config.latitude || ''}
                onChange={onChange('latitude')}
              />
            </LojaInputWrapper>
            <LojaInputWrapper>
              <InfoDescription label="Longitude" />
              <CustomInput
                type="text"
                value={config.longitude || ''}
                onChange={onChange('longitude')}
              />
            </LojaInputWrapper>
          </InputsLojaWrapper>
          <CustomButton
            appearance="primary"
            onClick={posicao}
            style={{ width: '100%', marginTop: 10 }}
          >
            <FaSearchLocation /> Localizar Agora
          </CustomButton>
        </SettingsCard>
        <SettingsCard>
          <CardHeader>
            <FaBullseye /> <h3>Eventos e Rastreio</h3>
          </CardHeader>
          <LojaInputWrapper>
            <InfoDescription label="Pixel Facebook" />
            <CustomInput
              type="text"
              value={config.faceBookPixel || ''}
              onChange={onChange('faceBookPixel')}
            />
          </LojaInputWrapper>
          <LojaInputWrapper>
            <InfoDescription
              label="Google Tag Manager"
              description="ID do contêiner (ex: GTM-XXXXXXX). Se o Pixel do Facebook também estiver configurado dentro do GTM, deixe o campo acima vazio para não duplicar eventos"
            />
            <CustomInput
              type="text"
              placeholder="GTM-XXXXXXX"
              value={config.googleTagManager || ''}
              onChange={onChange('googleTagManager')}
            />
          </LojaInputWrapper>
        </SettingsCard>
        <SettingsCard>
          <CardHeader>
            <img src={assasLogo} alt="Asaas" style={{ height: 20 }} />
          </CardHeader>
          <ToggleRow>
            <InfoDescription
              label="Habilitar Asaas"
              description="Ativa integração com Asaas para pagamentos"
            />
            <CustomToggle
              checked={config.enablePaymentAsaas}
              onChange={() =>
                change('enablePaymentAsaas', Number(!config.enablePaymentAsaas))
              }
            />
          </ToggleRow>
          <LojaInputWrapper>
            <InfoDescription label="Chave API" />
            <FlexRow>
              <CustomInput
                type="password"
                disabled
                value="****************"
                style={{ flex: 1 }}
              />
              <CustomButton
                appearance="primary"
                onClick={() => setInsertAsaasModal(true)}
              >
                Inserir
              </CustomButton>
            </FlexRow>
          </LojaInputWrapper>
          <LojaInputWrapper>
            <InfoDescription label="Expiração PIX (Min.)" />
            <CustomInput
              type="number"
              value={config.asaasExpirationTimePix}
              onChange={onChange('asaasExpirationTimePix')}
            />
          </LojaInputWrapper>
        </SettingsCard>
      </ContentLoja>
      {modalAgendamento && (
        <DataAgendamento
          modal={modalAgendamento}
          fecharModal={() => setModalAgendamento(false)}
          IdConfig={config.idConfig}
          refresh={atualizar}
          DiasAgendamento={config.diasAgendamento}
        />
      )}
      {insertAsaasModal && (
        <InsertAssasApiKey
          open={insertAsaasModal}
          onClose={() => setInsertAsaasModal(false)}
          id_empresa={id_empresa}
        />
      )}
    </ContainerLoja>
  );
};

export default Store;
